import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import {
    validateEmail,
    validateExpectLink,
    validateNotEmpty,
    validatePhoneNumber,
} from 'src_common/common/mobx-utils/Form2/validators';

const noEmptyValidationMessage = 'This field is required.';
const incorrectEmailValidationMessage = 'Incorrect e-mail format.';
const incorrectPhoneNumberValidationMessage =
    'Phone number should only contain numbers and spaces and be 7-15 characters long.';
const incorrectLinkValidationMessage = 'Link should begin with http:// or https:/';

export const createEmailInputState = (defaultValue: string): FormInputState<string, string> =>
    FormInputState.new(defaultValue).map(validateEmail(incorrectEmailValidationMessage));

export const createPhoneInputState = (defaultValue: string): FormInputState<string, string> =>
    FormInputState.new(defaultValue).map(validatePhoneNumber(incorrectPhoneNumberValidationMessage));

export const createLinkInputState = (defaultValue: string): FormInputState<string, string> =>
    FormInputState.new(defaultValue)
        .map(validateNotEmpty(noEmptyValidationMessage))
        .map(validateExpectLink(incorrectLinkValidationMessage));
